import script from "./Upload.vue?vue&type=script&lang=ts&setup=true"
export * from "./Upload.vue?vue&type=script&lang=ts&setup=true"

import "./Upload.vue?vue&type=style&index=0&id=48939807&lang=css"

const __exports__ = script;

export default __exports__